var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#4E72E6",
    fillOpacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_765_3888)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9602 35.967H16.99C16.4398 35.967 15.9934 35.5205 15.9934 34.9703V17.0301C15.9934 16.4799 16.4399 16.0334 16.99 16.0334H25.9602C26.5113 16.0334 26.9568 15.5879 26.9568 15.0368C26.9568 14.4856 26.5113 14.04 25.9602 14.04H16.99C15.3415 14.04 14 15.3816 14 17.0301V34.9703C14 36.6188 15.3415 37.9603 16.99 37.9603H25.9602C26.5113 37.9603 26.9568 37.5148 26.9568 36.9636C26.9568 36.4125 26.5113 35.967 25.9602 35.967Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7032 25.2905L31.6434 19.3104C31.2527 18.9237 30.6208 18.9287 30.2341 19.3204C29.8474 19.712 29.8514 20.3429 30.2441 20.7297L34.5746 25.0034H22.9703C22.4191 25.0034 21.9736 25.4489 21.9736 26C21.9736 26.5512 22.4191 26.9967 22.9703 26.9967H34.5746L30.2441 31.2705C29.8514 31.6572 29.8484 32.2881 30.2341 32.6798C30.3268 32.7738 30.4373 32.8485 30.5591 32.8995C30.6809 32.9505 30.8117 32.9768 30.9437 32.9768C31.1969 32.9768 31.45 32.8811 31.6434 32.6897L37.7032 26.7096C37.7972 26.6169 37.8718 26.5064 37.9228 26.3846C37.9738 26.2628 38.0001 26.132 38.0002 26C38.0002 25.733 37.8936 25.4788 37.7032 25.2905Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_765_3888"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(14 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.67d435d71f44607f9893c20239d91f92.svg";
export { ForwardRef as ReactComponent };